export default __webpack_public_path__ + "static/media/ui-ux.e629f33f.svg";